document.addEventListener("DOMContentLoaded", function () {
    // Mở popup khi click .inquire-button
    document.querySelectorAll(".inquire-button").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            var href = btn.getAttribute("href");
            if (href && href.startsWith("#")) {
                var popup = document.querySelector(href);
                if (popup) {
                    popup.classList.add("active");
                }
            }
        });
    });

    // Đóng popup khi click nút close
    document.querySelectorAll(".drop-hint-popup__close").forEach(function (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
            e.preventDefault();
            var popup = closeBtn.closest(".drop-hint-popup");
            if (popup) {
                popup.classList.remove("active");
            }
        });
    });
});